import { render } from "./OurSubsidiary.vue?vue&type=template&id=156111c0&scoped=true"
import script from "./OurSubsidiary.vue?vue&type=script&lang=js"
export * from "./OurSubsidiary.vue?vue&type=script&lang=js"

import "./OurSubsidiary.vue?vue&type=style&index=0&id=156111c0&scoped=true&lang=css"

import exportComponent from "/home/aria/Documents/gawean/pt.ksi/program/vue/ksi_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156111c0"]])

export default __exports__